module.exports = __webpack_public_path__ + "img/special_03.2e37f1e7.png";